import { MessagePresentational } from "./MessagePresentational";

export enum Severity {
  Error,
  Warning,
  Information,
  Success,
}

export type Props = {
  title: string;
  content: string;
  severity: Severity;
  className?: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;

  primaryAction?: () => void;
  secondaryAction?: () => void;
};

export const MessageContainer = (props: Props) => {
  return (
    <MessagePresentational
      title={props.title}
      content={props.content}
      severity={props.severity}
      className={props.className}
      primaryAction={props.primaryAction}
      secondaryAction={props.secondaryAction}
      primaryActionLabel={props.primaryActionLabel}
      secondaryActionLabel={props.secondaryActionLabel}
    />
  );
};
